import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=5ce9e81b"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports